import { Tab } from "@headlessui/react";
import { BlockWrapper } from "../Preview";
import React from "react";
import { generateContent, generateCss } from "../../functions/sortableFunctions";
const TabComponent = ({ block, ...props }: any) => {
    return (
        <React.Fragment>
            <Tab as={block.data?.type ? block.data.type : 'button'} id={block.id} className={generateCss({
                props: {
                    ...props,
                    block: block
                },
            })} style={{
                fontFamily: block?.style?.fontFamily
            }} >
                {
                    ({ selected }) => {
                        if (block.children) {
                            return block.children.map((value: any, index: any) => {
                                return <BlockWrapper
                                    {...props}
                                    key={index}
                                    block={value}
                                    selected={selected}
                                />
                            })
                        } else {
                            return generateContent({
                                props: {
                                    ...props,
                                    block: block
                                },
                            });
                        }
                    }
                }
            </Tab>

        </React.Fragment>

    )
}
export default TabComponent;